import { cfg } from 'config/runtimeConfig'
import { useEffect, useState } from 'react'
import * as api from 'api/entityApi'
import type { Option } from 'types/entity'

interface WebformFormProps {
  entityId: string
  onSuccess?: (msg: string) => void
  onCancel?: () => void
}

const LEGACY_BASE = (cfg('REACT_APP_LEGACY_BASE_URL') ?? '').replace(/\/+$/, '')

/**
 * The legacy Webform action did not save anything — it opened
 * webFormDetails.aspx in a popup window with the lead pre-bound.
 */
export function WebformForm({ entityId }: WebformFormProps) {
  const [webforms, setWebforms] = useState<Option[]>([])
  const [selectedForm, setSelectedForm] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string>('')

  useEffect(() => {
    let active = true
    async function loadWebforms() {
      try {
        const list = await api.fetchUserWebforms()
        if (!active) return
        setWebforms(list)
        if (list.length > 0) setSelectedForm(list[0].id)
      } catch {
        if (active) setError('Failed to load webforms.')
      } finally {
        if (active) setLoading(false)
      }
    }
    void loadWebforms()
    return () => {
      active = false
    }
  }, [])

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!selectedForm) {
      setError('Please select a webform.')
      return
    }
    setError('')
    const formName = webforms.find((w) => w.id === selectedForm)?.name ?? ''
    const { parentId, userId } = api.getSessionContext()
    window.open(
      `${LEGACY_BASE}/UserCRMCampaign/webFormDetails.aspx?ParentID=${parentId}&cName=${encodeURIComponent(formName)}&EntityName=Lead&AgentId=${userId}&EntityId=${entityId}`,
      'kit19Window',
    )
  }

  if (loading) return <div className="widget-loader">Loading Webforms…</div>

  return (
    <div className="action-form">
      {error && <div className="alert alert-error">{error}</div>}

      <div className="form-group">
        <label className="form-label" htmlFor="wf-select">
          Webform Name <span className="req">*</span>
        </label>
        <select
          id="wf-select"
          className="form-control"
          value={selectedForm}
          onChange={(e) => setSelectedForm(e.target.value)}
        >
          <option value="">-- Select Webform --</option>
          {webforms.map((w) => (
            <option key={w.id} value={w.id}>
              {w.name}
            </option>
          ))}
        </select>
      </div>

      <div className="form-hint" style={{ marginTop: 12 }}>
        The webform opens in a new window and its submission is linked to this record.
      </div>

      <div className="action-form-footer" style={{ marginTop: 24 }}>
        <button type="button" className="btn pri-btn" onClick={handleSubmit}>
          Fill Webform
        </button>
      </div>
    </div>
  )
}
